import React, { useState } from 'react';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import CustomInputWithIcon from '../../../common/ui/CustomInputWithIcon';
import ShowEnvConstantTable from './ShowEnvConstantTable';

const ListEnvironmentConstants = ({
  envId,
  envType,
  constants,
  projectId,
  version,
  appSetting,
  actions,
  deleteFlag,
}) => {
  const [activeEnvConstant, setActiveEnvConstant] = useState('');
  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <table className="table table-bordered table-hover table-stripped">
            <thead>
              <tr>
                <th>Name</th>
                <th>Value</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {constants.map((constant) => (
                <ShowEnvConstantTable
                  key={constant.uuid + envType}
                  constant={constant}
                  appSetting={appSetting}
                  actions={actions}
                  envId={envId}
                  envType={envType}
                  projectId={projectId}
                  version={version}
                  deleteFlag={deleteFlag}
                />
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ListEnvironmentConstants;
